import { render, staticRenderFns } from "./ProAppIntelligenceMessageList.vue?vue&type=template&id=312d163f&scoped=true&"
import script from "./ProAppIntelligenceMessageList.vue?vue&type=script&lang=js&"
export * from "./ProAppIntelligenceMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ProAppIntelligenceMessageList.vue?vue&type=style&index=0&id=312d163f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d163f",
  null
  
)

export default component.exports